import { Component, EventEmitter, Input, OnInit, Output, OnChanges } from '@angular/core';
import { Configuracoes } from 'src/app/entities/configuracoes';
import { ConfiguracoesSite } from 'src/app/entities/configuracoesSite';
import { ProductService } from 'src/app/services/product-service';
import { Options, LabelType, ChangeContext,PointerType  } from '@angular-slider/ngx-slider';
import { FormControl, FormGroup } from '@angular/forms';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'app-catalog-filter',
  templateUrl: './catalog-filter.component.html',
  styleUrls: ['./catalog-filter.component.css']
})
export class CatalogFilterComponent implements OnInit {
  // sliderForm: FormGroup = new FormGroup({
  //   sliderControl: new FormControl([20, 80])
  // });
  
  
  @Output() onFilter = new EventEmitter<any>();
  @Output() onClearSearch = new EventEmitter<any>();
  @Output() onTotalClear = new EventEmitter<any>();
  @Output() onItemClear = new EventEmitter<any>();
  @Output() onFilterClear = new EventEmitter<any>();
  @Output() onPriceFilter = new EventEmitter<any>();
  @Output() onClearSearchDescription = new EventEmitter<any>();
  @Output() filtrarPorMenuDinamico = new EventEmitter<number>();
  @Output() removeItemBusca = new EventEmitter<number>();
  @Output() breadCrumbEm = new EventEmitter<string>()

  @Input() filters: any;
  @Input() filtros: any;
  @Input() catalogItems: any[];
  filtersSearch: any;
  public SITE: ConfiguracoesSite;
  public menuDinamico: boolean;
  public dropdown: boolean
  public selected: any[]
  public breadCrumb: string = ""
  term: string = ""
  public filtroColapsado: boolean
  layoutMenu: number = 0
  // public breadCrumb: string =""
  JSON: any; 
  searchFilter: string = ''
  minValue: number = 0;
  maxValue: number = 400;

  logText: string = '';

  options: Options = {
    floor: 0,
    ceil: 500,
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Low:
          return 'R$' + value;
        case LabelType.High:
          return 'R$' + value;
        default:
          return 'R$' + value;
      }
    }
  };
  constructor(public productService: ProductService) {
    this.SITE = Configuracoes.SITE;
    this.menuDinamico = Configuracoes.MISC.menuDinamico;
    this.filtroColapsado = Configuracoes.filtroColapsado
    this.layoutMenu = Configuracoes.layoutMenu
    this.dropdown = false
    this.selected = []
  }

  ngOnInit() {
    this.filtersSearch = { ...this.filters }
    localStorage.removeItem("selectedItem")
    // localStorage.removeItem("breadCrumb")
    this.selected = []
  }
  ngOnChanges() {
    if (localStorage.getItem("selectedItem")) {
      this.selected = JSON.parse(localStorage.getItem("selectedItem"))
    } else {
      this.selected = [] 
    }
  }

  getBreadCrumb(bc){
    // this.breadCrumb = bc
    this.breadCrumbEm.emit(bc)
  }

  removeItem(item) {
    let arr = JSON.parse(localStorage.getItem("selectedItem"))
    let updatedItems = []
    for (const category of arr) {
      if (category.parent === item[0].parent) {
        for(let i = 0; i < category.items.length; i++){
          if(category.items[i].id !== item[1]){
            updatedItems.push(category.items[i])
          }
        }
        category.items = updatedItems;
        break; 
      }
    }
    arr = arr.filter(a => a.items.length !== 0)
    this.selected = arr
    // localStorage.setItem("selectedItem", JSON.stringify(arr));
    this.removeItemBusca.emit(arr);
  }
  onUserChangeEnd(changeContext: ChangeContext): void {
    console.log(`onUserChangeEnd(${this.getChangeContextString(changeContext)})\n`);
  }
  getChangeContextString(changeContext: ChangeContext): any[] {
    return [changeContext.value, changeContext.highValue];
  }
  public mappingArr(arr){
    return arr.map(a => a.nome)
  }


  onSearch(term: string, id: number) {
    this.term = term
    const a = [];
    for (let i = 0; i < this.filtersSearch[id].length; i++) {
      if (this.filtersSearch[id][i].nome.includes(term.toUpperCase())) {
        a.push(this.filtersSearch[id][i]);
      }
    }
    this.filters[id] = a;
  }
  // resetForm(): void {
  //   this.sliderForm.reset({sliderControl: [this.minValue, this.maxValue]});
  // }

}
